import { useContext, useEffect, useState } from 'react';

import { useParams } from 'react-router';

import Loading from '../../../Components/Loading/Loading';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { serverErrorHandler } from '../../../Utils/Helpers';
import Ranks from '../Components/CompetitionRegistersRanks/Ranks';
import Search from '../Components/CompetitionRegistersRanks/Search';
import { CompetitionContext } from '../Context/CompetitionContext';

const CompetitionRule = () => {
  const { id } = useParams();
  const { get, post, destroy } = useApi();
  const { success, error } = useToast();
  const [loadingSelectRank, setLoadingSelectRank] = useState(false);
  const context = useContext(CompetitionContext);
  const [loading, setLoading] = useState(true);
  const [selectRank, setSelectRank] = useState(undefined);
  const [ranks, setRanks] = useState([]);
  const [formSubmitLoading, setFormSubmitLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [serverErrors, setServerErrors] = useState({});

  useEffect(() => {
    const getData = async () => {
      await getCompetitionregisters();
      await getCompetition();
      await getProvinces();
      await getCompetitionRank();
    };
    getData();
  }, [id]);

  const getCompetitionregisters = async () => {
    setLoading(true);
    await get(
      `/competition/${id}/registers`,
      (res) => {
        context.competitionRegisters = res.data;
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };
  const getProvinces = async () => {
    setLoading(true);
    await get(
      `/province`,
      (res) => {
        context.provinces = res.data;
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };
  const getCompetition = async () => {
    setLoading(true);
    await get(
      `/competition/${id}`,
      (res) => {
        context.competition = res.data;
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };

  const getCompetitionRank = async () => {
    setLoading(true);
    await get(
      `/competition/${id}/rank`,
      (res) => {
        const getRanks = res.data.map((rank) => {
          return {
            id: rank.id,
            modelId:
              rank?.user?.id !== undefined
                ? rank?.user?.id
                : rank?.team?.id !== undefined
                ? rank?.team?.id
                : rank?.league?.id !== undefined
                ? rank?.league?.id
                : null,
            title:
              rank?.user?.name !== undefined
                ? rank?.user?.name + ' ' + rank?.user?.last_name
                : rank?.team?.name !== undefined
                ? rank?.team?.name
                : rank?.league?.name !== undefined
                ? rank?.league?.name
                : null,
            rank: rank.rank,
            type: rank?.type,
            // rank?.user?.id !== undefined
            //   ? 'user'
            //   : rank?.team?.id !== undefined
            //   ? 'team'
            //   : rank?.league?.id !== undefined
            //   ? 'league'
            //   : null,
            ethics_card: rank?.ethics_card,
            sport_id: rank?.sport?.id ?? 0,
            province_id: rank?.province?.id ?? 0,
            weight_id: rank?.weight?.id ?? 0,
            age_id: rank?.age?.id ?? 0,
          };
        });
        setRanks(getRanks);
        setLoading(false);
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };

  const changeRank = async () => {
    if (selectRank?.rank == undefined) {
      return error('لطفا مقام را انتخاب نمایید.');
    }
    const ranksCopy = await [...ranks];
    const rankFind = await ranksCopy?.find((r) => r.rank === selectRank?.rank);
    const typeFind = await ranksCopy?.find(
      (r) => r.type === selectRank?.type && r.modelId === selectRank?.modelId,
    );
    if (typeFind) {
      setLoadingSelectRank(false);
      return error('برای ایتم موردنظر قبلا مقام ثبت شده است');
    }
    if (rankFind) {
      setLoadingSelectRank(false);
      return error('این مقام قبلا ثبت شده است');
    }
    await ranksCopy.push(selectRank);
    await setRanks(ranksCopy);
    setLoadingSelectRank(false);
  };

  const changeEthicsCard = async (rank, value) => {
    const ranksCopy = await [...ranks];
    const rankFind = await ranksCopy?.findIndex((r) => r.rank === rank);
    ranksCopy[rankFind]['ethics_card'] = value;
    setRanks(ranksCopy);
  };

  const changeSportCard = async (rank, value) => {
    const ranksCopy = await [...ranks];
    const rankFind = await ranksCopy?.findIndex((r) => r.rank === rank);
    ranksCopy[rankFind]['sport_id'] = value;
    setRanks(ranksCopy);
  };

  const onChangeRank = async (name, index, value) => {
    const ranksCopy = await [...ranks];
    ranksCopy[index][name] = await value;
    await setRanks(ranksCopy);
  };

  const addRank = async (rank) => {
    const ranksCopy = await [...ranks];
    await ranksCopy.push(rank);
    await setRanks(ranksCopy);
    success(
      'ورزشکار با موفقیت اضافه شد لطفا اطلاعات ورزشکار را در جدول مقام ها ثبت نمایید در غیر اینصورت مقام بصورت اشتباه ثبت خواهد شد',
    );
  };

  const removerank = async (rank) => {
    setDeleteLoading(true);
    setLoadingSelectRank(true);
    const ranksCopy = [...ranks];
    let rankFind = ranksCopy?.[rank?.index];
    if (rankFind?.id != null && rankFind?.id !== undefined) {
      await destroy(
        `/competition/${id}/rank/${rankFind?.id}`,
        (res) => {},
        (err) => {
          error('حذف به علت خطا انجام نشد');
          setDeleteLoading(false);
          setLoadingSelectRank(false);
        },
      );
    }
    // console.log(ranksCopy.filter((r, i) => i != rank?.index));
    // await delete ranksCopy[rank.index];
    await setRanks((preveRanks) =>
      preveRanks.filter((r, i) => i != rank?.index),
    );
    // await setRanks(ranksCopy);
    success('با موفقیت حذف شد');
    setLoadingSelectRank(false);
    setDeleteLoading(false);
    setModalIsOpen(false);
  };

  const submitForm = async () => {
    if (ranks.length == 0) {
      return error('لطفا رده بندی را تکمیل نمایید');
    }
    setFormSubmitLoading(true);
    const data = {
      ranks: ranks,
      competition_id: id,
    };
    await post(
      `/competition/${id}/rank`,
      data,
      (res) => {
        success('رده بندی با موفقیت انجام شد');
        setFormSubmitLoading(false);
      },
      (err) => {
        error('ثبت رده بندی موفقیت آمیز نبود');
        setFormSubmitLoading(false);
      },
    );
  };

  const searchUser = async (values) => {
    setSearchLoading(true);
    let queryString = `?type=${values?.type}`;
    queryString +=
      values?.province_id?.length > 0
        ? `&province_id=${values?.province_id}`
        : '';
    queryString +=
      values?.national_card_id?.length > 0
        ? `&national_card_id=${values?.national_card_id}`
        : '';
    await get(
      `/competition/${id}/rank/search${queryString}`,
      (res) => {
        setServerErrors({});
        const { data } = res;
        if (data?.length === 0) {
          setSearchLoading(false);
          return error('ورزشکاری با اطلاعات وارد شده یافت نشد!');
        }
        data.forEach((el, index) => {
          data[index]['type'] =
            values['type'] == 1
              ? 'user'
              : values['type'] == 2
              ? 'team'
              : values['type'] == 3
              ? 'league'
              : null;
        });
        context.users = data;
        setSearchLoading(false);
      },
      (err) => {
        setSearchLoading(false);
        if (err?.status === 422) {
          context.users = {};
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error('دریافت اطلاعات با خطا مواجه شد');
        }
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='row'>
        {/* <List
          data={context.competitionRegisters}
          changeRank={changeRank}
          setSelectRank={setSelectRank}
        /> */}
        <Search
          searchUser={searchUser}
          context={context}
          searchLoading={searchLoading}
          serverErrors={serverErrors}
          addRank={addRank}
        />
        <Ranks
          ranks={ranks}
          removeRank={removerank}
          loadingSelectRank={loadingSelectRank}
          removeLoading={deleteLoading}
          modalIsOpen={modalIsOpen}
          changeEthicsCard={changeEthicsCard}
          setModalIsOpen={setModalIsOpen}
          competition={context.competition}
          changeSportCard={changeSportCard}
          onChangeRank={onChangeRank}
        />
        <div className='col-12 d-flex flex-row justify-content-center my-4'>
          {formSubmitLoading ? (
            <button className='btn bg-persian-green f-12 text-white py-2 px-3'>
              <div
                className='spinner-border text-white spinner-border-sm mb-1'
                role='status'
              >
                <span className='sr-only'></span>
              </div>
            </button>
          ) : (
            <button
              onClick={submitForm}
              className='btn f-12 bg-persian-green text-white py-2 px-3'
            >
              ذخیره اطلاعات
            </button>
          )}
        </div>
      </div>
    </Master>
  );
};

export default CompetitionRule;
